import { useNavigate, useLocation } from 'react-router-dom'
import { useAdminPendingCount } from '../hooks/useAdminPendingCount'
import { useRequestsUnread } from '../hooks/useRequestsUnread'
import { useSelfProfile } from '../hooks/useSelfProfile'
import { NavBadge } from './NavBar'
import { UserAvatar } from './UserAvatar'
import { fbt } from 'fbtee'

export function UserMenu() {
  const { isUser, profile, profileLoading } = useSelfProfile()
  const adminPendingCount = useAdminPendingCount()
  const requestsUnread = useRequestsUnread(false)
  const navigate = useNavigate()
  const location = useLocation()

  if (!isUser) {
    return (
      <button
        type="button"
        onClick={() => navigate('/login', { state: { from: location } })}
        className="h-10 inline-flex items-center text-sm font-medium text-foreground hover:text-foreground/80 cursor-pointer"
      >
        {fbt('Log in', 'Header link for unauthenticated visitors to navigate to the login page')}
      </button>
    )
  }

  return (
    <button
      type="button"
      onClick={() => navigate('/profile', { replace: true })}
      aria-label={fbt('Profile', 'Accessible label for the header avatar button that opens the profile page')}
      className="relative flex rounded-full cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      <UserAvatar loading={profileLoading} profile={profile} size="lg" />
      <NavBadge count={adminPendingCount + requestsUnread} testId="header-profile-badge" />
    </button>
  )
}
